export default __webpack_public_path__ + "static/media/3.fceb7a1f.png";